"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ALERT_BLUE: '#004ECC',
    ALERT_ORANGE: '#CE7F30',
    ALERT_RED: '#9B1E1E',
    BRAND_BLACK: '#0E1016',
    BRAND_BLUE: '#012343',
    BRAND_BORDER_BLUE: '#2C4058',
    BRAND_DARK_BLUE: '#000D1E',
    BRAND_GRADIENT: 'radial-gradient(78.73% 97.55% at 116.49% 121.29%, #00376D 0%, #001425 100%);',
    BRAND_GRADIENT_DARK: '#001425',
    BRAND_GRADIENT_LINEAR_BLUE: 'linear-gradient(135deg, #041A3C 0%, #011A35 100%)',
    BRAND_GRAY_LIGHT_BLUE: '#2A404E',
    BRAND_GREEN: '#19AF62',
    BRAND_GREY: '#DCDCDE',
    BRAND_ICON_BLUE: '#004ECC',
    BRAND_LIGHT_BLUE: '#E7EFFA',
    BRAND_LIGHT_GRAY: '#F5F5F5',
    BRAND_LIGHT_GREEN: '#EDF9F3',
    BRAND_LIGHT_RED: '#F7E6E9',
    BRAND_PREMIUM_BLUE: '#001428',
    BRAND_PREMIUM_GREY: '#B0B2B9',
    BRAND_RED: '#980A24',
    BRAND_WHITE: '#FFFFFF',
    BRAND_X_BLUE: '#041A3C',
    CTA_HIT_GREY: '#A2AAAD',
    DARK_GREY: '#6C6D73',
    DIGITAL_DARK_GREY: '#6C6D73',
    DIGITAL_LIGHT_GREY: '#E4E7ED',
    DIGITAL_LIGHTER_GREY: '#F4F5F9',
    DIGITAL_MIDNIGHT_BLUE: '#000D1E',
    DIGITAL_OFF_GREY: '#FBFBFB',
    DIGITAL_TEXT: '#3A3B3F',
    FUNCTIONAL_BLUE: '#004ECC',
    FUNCTIONAL_LIGHT_ORANGE: '#FBF1E7',
    FUNCTIONAL_ORANGE: '#DB7917',
    FUNCTIONAL_RED: '#B50D2B',
    GREY100: '#EEEEEE',
    GREY300: '#CCCCCC',
    GREY50_PERCENT: '#ECECED',
    PRODUCT_PURPLE: '#9400D3',
    PRODUCT_YELLOW: '#CCCC00',
    TEXT_GREY: '#4B4D52',
};
